import OrderService from '../../common/interfaces/OrderService';
import { axiosInstance } from '../axios';
import {
  isBefore,
  isAfter,
  isWeekend,
  isSameDay,
  addDays,
  startOfDay,
  addHours,
} from 'date-fns';

interface Variables {
  orderServiceId: string;
  dateReschedule: Date;
  dateRescheduleWithTime?: Date;
  dateToday?: Date;
}

export async function rescheduleOrderService(variables: Variables) {
  return await axiosInstance.post(
    `/order-service/${variables.orderServiceId}/reschedule`,
    variables
  );
}

function isScheduledForNextDay(
  solicitationDate: Date,
  inspectionDate: Date
): boolean {
  const nextCalendarDay = addDays(startOfDay(solicitationDate), 1);
  return isSameDay(startOfDay(inspectionDate), nextCalendarDay);
}

function addBusinessHours(date: Date, hours: number): Date {
  let result = new Date(date);
  let added = 0;

  while (added < hours) {
    result = addHours(result, 1);
    if (!isWeekend(result)) {
      added++;
    }
  }

  return result;
}

export function shouldAllowReschedule(
  data: OrderService,
  now: Date = new Date()
) {
  if (!data.date_solicitation) return false;

  const solicitationDate = new Date(data.date_solicitation);
  const inspectionDate = new Date(
    data.date_inspection ?? data.date_schedule_inspection
  );

  if (Number.isNaN(inspectionDate.getTime())) return false;

  if (isScheduledForNextDay(solicitationDate, inspectionDate)) {
    return !isAfter(now, addHours(solicitationDate, 1));
  }

  const deadline = addBusinessHours(solicitationDate, 48);
  return isBefore(now, deadline);
}

export function isValidRescheduleDate(date: Date) {
  const isAfterDate = isAfter(date, Date.now());
  const isNotWeekend = !isWeekend(date);

  return isAfterDate && isNotWeekend;
}

export function removeOrderServiceAttachment(attachmentId: string) {
  return axiosInstance.post(
    `/order-service/${attachmentId}/remove-attachment`
  );
}

interface UpdateVariables {
  id: string;
  description: string;
}

export function updateOrderServiceObservation(variables: UpdateVariables) {
  return axiosInstance.put(`/client/order-service/${variables.id}/update`, {
    id: variables.id,
    data: {
      description_client: variables.description,
    },
  });
}
